module.exports = __webpack_public_path__ + "static/img/106.651c5ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210407/106.jpg
// module id = NLGb
// module chunks = 0